import { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import type { OnboardingStepProps } from '../../registration';
import { usePwaInstall } from '../../../../hooks/use-pwa-install';
import { isNative } from '../../../../platform';
import { VSpace } from '../../../chat/settings/account/account-settings';
import { Install } from '../install/install';
import {
  ContentSection,
  Heading,
  SubHeading,
  ScanLabel,
  QrContainer,
} from './qr-code.styled';

const APP_URL = import.meta.env.VITE_APP_BASE_URL || window.location.origin;

export const NATIVE_APPS_LIVE = true;

export const QrCodeScreen: React.FC<OnboardingStepProps> = ({ goNext }) => {
  const { isStandalone, isIos, isAndroid } = usePwaInstall();

  const isSmallScreen = typeof window !== 'undefined' && window.innerWidth < 768;
  const isMobile = isIos || isAndroid || isSmallScreen;

  // Auto-advance if user is already on standalone PWA or native app
  useEffect(() => {
    if (isStandalone || isNative()) {
      goNext();
    }
  }, [isStandalone, goNext]);

  if (isStandalone || isNative()) return null;

  return (
    <ContentSection data-testid="ob-qr-code">
      <VSpace $h={24} />

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <Heading data-testid="ob-qr-heading">Your access is active.</Heading>
        <SubHeading data-testid="ob-qr-subheading">
          Your 14-day trial has started.
          <br />
          Install Mailander on your phone to continue.
        </SubHeading>
      </div>

      {!isMobile && (
        <>
          <ScanLabel data-testid="ob-qr-scan-label">Scan the QR code to install the app</ScanLabel>

          <QrContainer data-testid="ob-qr-container">
            <QRCodeSVG value={APP_URL} size={170} level="M" />
          </QrContainer>
        </>
      )}

      {isMobile && (
        <Install goNext={goNext} goPrev={() => {}} goTo={() => {}} stepIndex={4} />
      )}
    </ContentSection>
  );
};

(QrCodeScreen as any).background = 'linear-gradient(180deg, #222327 0%, #1A1A1C 100%)';
(QrCodeScreen as any).progress = false;
(QrCodeScreen as any).smallLogo = true;
(QrCodeScreen as any).showLogo = true;
(QrCodeScreen as any).containerAlign = 'center';
(QrCodeScreen as any).containerJustify = 'flex-start';
